function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m49.796 2.3604-32.512 32.512a13.243 13.243 0 0 0-3.904 9.4267v3.5813a2.6667 2.6667 0 0 0 2.6667 2.6667h3.5813a13.243 13.243 0 0 0 9.4267-3.904l32.512-32.512a8.3333 8.3333 0 0 0 0-11.771 8.5173 8.5173 0 0 0-11.771 0zm8 8-32.512 32.512a8.0533 8.0533 0 0 1-5.656 2.3413h-0.91467v-0.91467a8.0533 8.0533 0 0 1 2.3413-5.656l32.512-32.512a3.0613 3.0613 0 0 1 4.2293 0 2.9947 2.9947 0 0 1 0 4.2293z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.333 23.944a2.6667 2.6667 0 0 0-2.6667 2.6667v13.389h-10.667a8 8 0 0 0-8 8v10.667h-26.667a8 8 0 0 1-8-8v-37.333a8 8 0 0 1 8-8h24.112a2.6667 2.6667 0 1 0 0-5.3333h-24.112a13.349 13.349 0 0 0-13.333 13.333v37.333a13.349 13.349 0 0 0 13.333 13.333h30.248a13.248 13.248 0 0 0 9.4293-3.904l7.0827-7.088a13.248 13.248 0 0 0 3.9067-9.4267v-16.971a2.6667 2.6667 0 0 0-2.6667-2.6667zm-12.093 32.381a7.9333 7.9333 0 0 1-3.9067 2.1333v-10.459a2.6667 2.6667 0 0 1 2.6667-2.6667h10.467a8.0427 8.0427 0 0 1-2.1333 3.904z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3dbbe1ae.svg";
export { ForwardRef as ReactComponent };